import task from "@commons/task";
import {sa2Toast, sa2Confirm, sa2Alert} from "@commons/sa2Custom";
import {__t} from "@commons/i18nRef";
import Utils from "../../../Utils/Utils";
import {attachSelect2, attachDestinationSelect2} from "@shared/rankedAreaSelect2";
import {missingAreaMessage} from "@shared/rankedAreas";
import {applyClustersResponse, latestRequestOnly, requestClustersForDeparture} from "@shared/a2bClusters";

//Car
export default function form(content, nextState, vrs) {// content div della view
    const {context, requestData, assetType} = vrs.session;

    var modal = $(content).closest('.modal');
    var errorMsgEl = $(".user-msg", content).hide().html("");
    var form = $("form", content);// form ricerca

    var departureParkingArea = $('[name=departureParkingAreaId]', form);
    var destinationParkingArea = $('[name=destinationParkingAreaId]', form);

    //Car pooling
    var cpAvailable = $('.car-pooling', form).length;
    var cpAcceptanceInput = $("input[name=passengersAccepted]", form);

    var cpSeatWrap = $(".booking-seat-count-wrap", form);
    var cpSeatInput = $("input[name=seatsCount]", form);

    var cpReasonWrap = $(".car-pooling-reason-wrap", form);
    var cpReasonInput = $("select[name=carPoolingRefuseReasons]", form);

    if (cpAvailable) {
        $(cpAcceptanceInput).prop("disabled", false);

        $(cpAcceptanceInput).on("change", function () {

            if (this.checked) {

                $(cpSeatWrap).show();
                $(cpSeatInput).prop("disabled", false);
                $(cpSeatInput).val($(cpSeatInput).attr('min'));

                if ($(cpReasonWrap).length) {
                    $(cpReasonWrap).hide();
                    $(cpReasonInput).prop("disabled", true);
                }

            } else {

                $(cpSeatWrap).hide();
                $(cpSeatInput).prop("disabled", true);

                if ($(cpReasonWrap).length) {
                    $(cpReasonWrap).show();
                    $(cpReasonInput).prop("disabled", false);
                }
            }

        }).trigger("change");
    }

    if ($(".booking-seat-count-wrap", content).length) {
        Utils.registerNumberSpinner(form, content);
    }

    var startDate = $("[name=startDate]", content);
    var endDate = $("[name=endDate]", content);

    $(startDate).datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: "L",
        minDate: new Date(),
        onSelect: function (date) {
            Utils.updateBookingTimeRestriction(startDate, endDate, assetType, true);
        }
    });

    $(endDate).datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: "L",
        minDate: new Date()
    });

    Utils.updateBookingTimeRestriction(startDate, endDate, assetType);

    $(form).off().on("submit", function (e) {
        e.preventDefault();

        $(errorMsgEl).hide().html("");
        vrs.clearXhrs();
        context.setLoading(true);

        var xhr = $.post(task("Booking.searchCar"), Utils.serializeForm(form), function (data) {

            if (!data.success) {// Errore durante la ricerca
                $(errorMsgEl).html(data.message).show();
                return;
            }

            vrs.goToView("solutions", {
                html: data.html
            });

        }).fail(function (xhr, status, error) {
            if (status !== "abort") {
                sa2Toast(__t("Errore durante la ricerca"), 'error', status);
            }
        }).always(function () {
            context.setLoading(false);
        });

        vrs.registerXhrs(xhr);
    });

    // Two quick departure changes must not let the older departure's clusters arrive last and win.
    var sendLatestClustersRequest = latestRequestOnly(Utils.abortXhr);

    function updateDestinationClusters(onChange = false) {
        requestClustersForDeparture($(departureParkingArea).val(), function (departureParkingAreaId) {
            sendClustersRequest(departureParkingAreaId, onChange);
        });
    }

    function sendClustersRequest(departureParkingAreaId, onChange) {
        var request = {
            departureParkingAreaId: departureParkingAreaId,
            assetType: "CAR"
        };

        // Aborting the previous request runs its always() and clears the loading state, so it is set afterwards.
        var xhr = sendLatestClustersRequest(function () {
            context.setLoading(true);
            return $.post(task("Booking.getA2bClusters"), request, function (response) {

                if (!response.success) {
                    $(modal).modal('hide');
                    sa2Toast(response.message, 'error');
                    return;
                }

                applyClustersResponse(destinationTiers, response.clusters, {
                    onChange: onChange,
                    departureId: departureParkingAreaId,
                    requestedDestinationId: requestedDestinationId,
                });

            }).fail(function (xhr, status, error) {
                if (status !== "abort") {
                    sa2Toast(__t("Errore durante la ricerca"), 'error', status);
                    $(modal).modal('hide');
                }
            }).always(function () {
                context.setLoading(false);
            });
        });

        vrs.registerXhrs(xhr);
    }

    var areaGroupLabels = {primary: __t("I tuoi depositi"), others: __t("Altri depositi")};

    // No data-rank-enabled: the departure is fixed by the booking's asset and the block is hidden.
    if ($(departureParkingArea).length && departureParkingArea.is("[data-rank-enabled]")) {
        attachSelect2($(departureParkingArea)[0], {
            rankEnabled: $(departureParkingArea).data("rank-enabled") === 1,
            requestedId: String($(departureParkingArea).data("requested-area") ?? ""),
            moreLabel: __t("Mostra altro"),
            missingMessage: missingAreaMessage(
                __t("%s non è più disponibile, selezionane un altro"),
                __t("Il deposito scelto non è più disponibile, selezionane un altro"),
                $(departureParkingArea).attr("data-missing-area-name") || ""
            ),
            placeholderLabel: __t("---Seleziona---"),
            groupLabels: areaGroupLabels,
            dropdownParent: $(departureParkingArea).parent(),
            theme: "bootstrap4",
        });
    }

    // The destination lists only what it allows (all areas, or the A2B clusters of the departure) in rank tiers.
    var requestedDestinationId = String($(destinationParkingArea).data("requested-area") ?? "");
    var destinationTiers = $(destinationParkingArea).length ? attachDestinationSelect2($(destinationParkingArea)[0], {
        rankEnabled: $(destinationParkingArea).data("rank-enabled") === 1,
        requestedId: requestedDestinationId,
        moreLabel: __t("Mostra altro"),
        missingMessage: missingAreaMessage(
            __t("%s non è più disponibile, selezionane un altro"),
            __t("Il deposito scelto non è più disponibile, selezionane un altro"),
            $(destinationParkingArea).attr("data-missing-area-name") || ""
        ),
        placeholderLabel: __t("---Seleziona---"),
        groupLabels: areaGroupLabels,
        dropdownParent: $(destinationParkingArea).parent(),
        theme: "bootstrap4",
    }) : null;

    $(content).on("change", "[name=departureParkingAreaId]", function () {

        if (destinationTiers) {

            if ($(destinationParkingArea).hasClass("use-clusters")) {
                updateDestinationClusters(true);
            } else {
                destinationTiers.setAllowed(null, $(this).val());
            }
        }

    });

    if ($(destinationParkingArea).length && $(destinationParkingArea).hasClass("use-clusters") && !vrs.session.hasOwnProperty("clustersInit")) {
        updateDestinationClusters(false);
        vrs.session["clustersInit"] = true;
    }

    $(content).on('click', ".btn-add-destination", function (e) {
        e.preventDefault();
        vrs.goToView("add-destination", {});
    });

    $(content).on('click', ".btn-trip-mode-type", function (e) {
        if ($(this).hasClass("pe-none")) {
            e.preventDefault();
        }
    });

    $(content).on('keydown', ".btn-trip-mode-type", function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    return function () {
        $(startDate).datepicker("destroy");
        $(endDate).datepicker("destroy");
        // The area selectors stay attached: the router shows this view again on the same DOM (back from a later
        // step) and the second attach keeps the user's choice; a new form brings new elements.
    }
};
